import { computed, type ComputedRef, type Ref } from 'vue'

export function useFiltersCount(
    items: Readonly<Ref<boolean[]>>
): ComputedRef<number> {
    return computed(() => items.value.filter(Boolean).length)
}
